(function () {
  function parseProductJSON(scriptEl) {
    if (!scriptEl) return null;
    try { return JSON.parse(scriptEl.textContent || scriptEl.innerText || '{}'); }
    catch (e) { return null; }
  }

  function findProductJSONForForm($form) {
    // procura o JSON do product mais próximo do form
    var idAttr = $form.getAttribute('data-section-id') || $form.getAttribute('data-product-id');
    var byId   = idAttr ? document.querySelector('#ProductJson-' + idAttr) : null;
    if (byId) return byId;

    // fallback: primeiro ProductJson visível na página
    return document.querySelector('script[id^="ProductJson-"]');
  }

  function valuesForOption(productData, optionIndex /*0-based*/) {
    // suporta tanto options_with_values como options
    if (productData && productData.options_with_values && productData.options_with_values[optionIndex]) {
      return productData.options_with_values[optionIndex].values || [];
    }
    if (productData && productData.options && productData.options[optionIndex]) {
      // algumas builds dão apenas strings das options; nesse caso não há values
      return [];
    }
    return [];
  }

  function getCurrentSelections($fieldsets) {
    var res = {};
    $fieldsets.forEach(function (fs, i) {
      var checked = fs.querySelector('.single-option-selector__radio:checked');
      if (checked) res['option' + (i + 1)] = checked.value;
    });
    return res;
  }

  function findVariant(productData, selections) {
    if (!productData || !productData.variants) return null;
    return productData.variants.find(function (v) {
      return (!selections.option1 || v.option1 === selections.option1) &&
             (!selections.option2 || v.option2 === selections.option2) &&
             (!selections.option3 || v.option3 === selections.option3);
    }) || null;
  }

  function fixForm($form) {
    var productJsonEl = findProductJSONForForm($form);
    var productData   = parseProductJSON(productJsonEl);
    if (!productData) return;

    var fieldsets = Array.prototype.slice.call($form.querySelectorAll('fieldset.single-option-radio'));
    if (!fieldsets.length) return;

    // 1) Corrigir labels/valores repetidos: para cada fieldset usar os values da respetiva option
    fieldsets.forEach(function (fs, idx) {
      var vals = valuesForOption(productData, idx);
      if (!vals.length) return; // se o JSON não tiver os valores, não toques

      var radios = fs.querySelectorAll('input.single-option-selector__radio');
      radios.forEach(function (input, i) {
        var label = $form.querySelector('label[for="' + input.id + '"]');
        if (!label || !vals[i]) return;

        // mantém HTML adicional (ex.: <i>…</i>) mas troca o texto final pelo value correto
        var extra = '';
        var m = label.innerHTML.match(/^(<i>.*?<\/i>\s*)/i);
        if (m) extra = m[1];
        label.innerHTML = extra + vals[i];
        input.value = vals[i];
      });
    });

    // 2) Sempre que um radio muda, sincroniza o <select name="id"> com o variant correto
    var select = $form.querySelector('select[name="id"]');
    if (!select) return;

    $form.addEventListener('change', function (e) {
      if (!e.target.classList.contains('single-option-selector__radio')) return;
      var selections = getCurrentSelections(fieldsets);
      var variant    = findVariant(productData, selections);
      if (variant) {
        select.value = String(variant.id);
        // dispara event para temas que escutam ao change do select
        var evt = document.createEvent('HTMLEvents');
        evt.initEvent('change', true, true);
        select.dispatchEvent(evt);
      }
    });
  }

  function init() {
    document.querySelectorAll('.product-single__form').forEach(fixForm);
    // idem para a secção de subscrição, que usa uma estrutura semelhante
    document.querySelectorAll('.subscription-product').forEach(fixForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
